import styled from 'styled-components';

export const InfoBlock = styled.div`
  width: 300px;
  max-width: 100%;
  min-width: 0;

  .pencil {
    cursor: pointer;

    :hover {
      color: var(--color-text-muted);
    }
  }
`;
